export default function SiteBody(prop: { children: any }) {
	return <div id="siteBody">{prop.children}</div>;
}
